exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput.form-control {\n&:disabled {\n        background: #f7f7f7;\n}\n}\n", ""]);

// exports
